// Types
import { Dispatch } from 'types'

export const actions = {
  registerExperiment: (experimentId: string, nrOfVariants: number) => (dispatch: Dispatch) => {
    dispatch({
      type: 'REGISTER_EXPERIMENT',
      experimentId,
      nrOfVariants,
    })
  },
}
